import styled from 'styled-components';

const StyledUserSelectDropdown = styled.div`
  background-color: ${props => props.theme.colors.neutral_1};
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),0 3px 6px -4px rgba(0, 0, 0, 0.12),0 9px 28px 8px rgba(0, 0, 0, 0.05);
  padding: 8px;
  width: 200px;

  .ant-dropdown-menu {
    box-shadow: none;
    max-height: 200px;
    overflow: auto;
    padding: 0;
  }

  input {
    margin-bottom: 8px;
  }
`;

export {
  StyledUserSelectDropdown,
};
